<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="title_page">Snark</h1>
<h2 class="center" style="margin-top:20px;">A Clifford Driscoll Mystery</h2>
<h3 class="center" style="margin-top:80px;">William L. DeAndrea</h3>
<p class="center" style="margin-top:80px;"><span><img alt="mp" src="mp.jpg"/></span></p>
<p class="center" style="margin-top:20px;"><span><img alt="logo" src="logo.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 2title_page.vue?59a83692